module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "card-face-container"
  }, [_c('img', {
    staticClass: "card-bg",
    attrs: {
      "src": require("../../../static/img/home/health_card_bg.png"),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-detail-info"
  }, [_c('div', {
    staticClass: "card-user-info"
  }, [_c('span', {
    staticClass: "card-user-name"
  }, [_vm._v(_vm._s(_vm.data.holderName))]), _vm._v(" "), _c('span', {
    staticClass: "card-user-id"
  }, [_vm._v(_vm._s(_vm._f("dotted")(_vm.data.cardNo)))])]), _vm._v(" "), _c('div', {
    staticClass: "card-qrcode"
  }, [_c('img', {
    staticClass: "card-qrcode-logo",
    attrs: {
      "src": require("../../../static/img/card-logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    ref: "qrCodeUrl",
    attrs: {
      "id": "qrCodeUrl"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("中华人民共和国国家卫生健康委员会监制")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-info"
  }, [_c('div', {
    staticClass: "card-top-org"
  }, [_vm._v("四川省卫生健康委员会")]), _vm._v(" "), _c('div', {
    staticClass: "card-top-title"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/icon-red-ten.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("电子健康卡")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6231c59e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/health-card-swiper/health-card.vue
// module id = 840
// module chunks = 0